import { render, staticRenderFns } from "./ModalOthersGoals.vue?vue&type=template&id=5cac4e18&scoped=true&lang=pug&"
import script from "./ModalOthersGoals.vue?vue&type=script&lang=ts&"
export * from "./ModalOthersGoals.vue?vue&type=script&lang=ts&"
import style0 from "./ModalOthersGoals.vue?vue&type=style&index=0&id=5cac4e18&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cac4e18",
  null
  
)

export default component.exports